// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Ql-z","tupacHeader":"Rl-z","tupacHeader2":"Sl-z","tupacMenu":"Tl-z","tupacMenu2":"Ul-z","tupacMain":"Vl-z","tupacMain2":"Wl-z"};